import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/delay';
import { Observable } from 'rxjs/Observable';
import { Arteh } from './data/Arteh';
import { Artstamm } from './data/Artstamm';
import { ArtstammScan } from './data/ArtstammScan';
import { Lager } from './data/Lager';
import { LagerplatzStartEtikettResult } from './data/LagerplatzStartEitkettResult';
import { OffeneBestellung } from './data/OffeneBestellung';
import { ScanArtikelResult } from './data/ScanArtikelResult';
import { IServerProvider } from './server-provider';

export class DemoBarcode {
    public barcode: string;
    public isStart = false;
    public isEnde = false;
    public isOffeneBestellung = false;
    public cartikelnummer: string;
    public artbez1: string;

    public constructor(init?: Partial<DemoBarcode>) {
        Object.assign(this, init);
    }
}

export class ServerProviderMock implements IServerProvider {

    private static demoBarcodes: Array<DemoBarcode>;

    public static getDemoBarcodes(): Array<DemoBarcode> {
        if (!this.demoBarcodes) {
            this.demoBarcodes = [];
            this.demoBarcodes.push(new DemoBarcode({ barcode: 'LPAFA81701-9', isStart: true }));
            this.demoBarcodes.push(new DemoBarcode({ barcode: '4008224585927', cartikelnummer: '908469', artbez1: '"Milano" Rahmen 2-fach buche' }));
            this.demoBarcodes.push(new DemoBarcode({ barcode: '4008224425506', cartikelnummer: '915585', artbez1: '"Milano" Steckdose', isOffeneBestellung: true }));
            this.demoBarcodes.push(new DemoBarcode({ barcode: '4008224425353', cartikelnummer: '915571', artbez1: '"Milano" Aus-/Wechselschalter' }));
            this.demoBarcodes.push(new DemoBarcode({ barcode: '4008224585828', cartikelnummer: '905477', artbez1: 'Milano Abdeckrahmen 2-fach anthrazit' }));
            this.demoBarcodes.push(new DemoBarcode({ barcode: 'LPEFA81701-9', isEnde: true }));
        }
        return this.demoBarcodes;
    }

    constructor() {

    }

    public scanLagerplatzStartEtikett(barcode: string): Observable<LagerplatzStartEtikettResult> {
        const demobarcodes = ServerProviderMock.getDemoBarcodes();
        for (let i = 0; i < demobarcodes.length; i++) {
            const demobarcode = demobarcodes[i];
            if (demobarcode.barcode === barcode) {
                if (demobarcode.isStart) {
                    const result = new LagerplatzStartEtikettResult();
                    return Observable.of(result);
                }
                return Observable.throw(`Barcode ${barcode} ist kein Startetikett`)
            }
        }

        return Observable.throw(`Ungültiger Barcode ${barcode}`)
    }

    public scanArtikel(eancode: string): Observable<ScanArtikelResult> {
        const demobarcodes = ServerProviderMock.getDemoBarcodes();
        for (let i = 0; i < demobarcodes.length; i++) {
            const demobarcode = demobarcodes[i];
            if (demobarcode.barcode === eancode) {
                const result = new ScanArtikelResult();
                result.warnmeldung = null;

                if (demobarcode.isStart) {
                    return Observable.throw(`Ungültiger Barcode ${eancode}`)
                }
                if (demobarcode.isEnde) {
                    result.endetikett = true;
                } else {
                    result.endetikett = false;
                    result.artstammScan = new ArtstammScan();
                    result.artstammScan.artstamm = new Artstamm();
                    result.artstammScan.artstamm.idartstamm = 1;
                    result.artstammScan.artstamm.cartikelnummer = demobarcode.cartikelnummer;
                    result.artstammScan.artstamm.artbez1 = demobarcode.artbez1
                    result.artstammScan.artstamm.artbez2 = '';
                    result.artstammScan.artstamm.eancode = eancode;
                    result.artstammScan.offeneBestellungen = [];

                    if (demobarcode.isOffeneBestellung) {
                        const offeneBestellung = new OffeneBestellung();
                        offeneBestellung.arteh = new Arteh();
                        offeneBestellung.arteh.arteh = 'STK';
                        offeneBestellung.belegdatum = new Date();
                        offeneBestellung.belegnummer = (new Date()).getTime();
                        offeneBestellung.lager = new Lager();
                        offeneBestellung.lager.lager = 'Test1';
                        offeneBestellung.lager.name1 = 'Test1';
                        offeneBestellung.menge = 10;
                        result.artstammScan.offeneBestellungen.push(offeneBestellung);
                    }
                }
                return Observable.of(result);
            }
        }

        return Observable.throw(`Ungültiger Barcode ${eancode}`)
    }

    public scanErgebnis(idartstammListe: number[]): Observable<boolean> {
        console.log('sende:');
        console.log(idartstammListe);

        return Observable.of(true).delay(2000);
    }
}



// WEBPACK FOOTER //
// ./src/providers/rest-server/server-provider-mock.ts